import Store from '@/store';
import PTC_Dashboard from '@/api/PTC/PTC_Dashboard.client';
import Notifier from '@/libs/Notifier';
import store from '@/store';

export default class PTC_DashboardService {
  constructor() {
    this.client = new PTC_Dashboard();
    this.store = Store;
    this.notify = new Notifier();
  }

  async RetornaCardsTotais(query) {
    try {
      this.store.commit('PTC_Dashboard/SET_IS_LOADING', true);
      const data = await this.client.retornaDashbord(query);
      this.store.commit('PTC_Dashboard/SET_DASHBOARD', data);

      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_Dashboard/SET_IS_LOADING', false);
    }
  }
}
